import { Button, Flex, Link, Stack } from '@chakra-ui/react';
import { FiTrash2 } from 'react-icons/fi';
import { IObjectFile } from '../../../services/hooks/Registration/useGetRegistration';

interface Props {
  attachments?: IObjectFile[] | null;
  onRemove?: (id: string) => void;
}

const PcdAttachments: React.FC<Props> = ({ attachments, onRemove }) => {
  if (!attachments?.length) return null;

  return (
    <Stack as="ul" aria-label="Laudos PCD enviados" spacing={1.5} m={0} p={0} w="full" minW={0} listStyleType="none">
      {attachments.map((attachment) => (
        <Flex
          as="li"
          key={attachment.id}
          align="center"
          gap={2}
          px={3}
          py={1.5}
          minH="40px"
          minW={0}
          borderWidth="1px"
          borderColor="gray.200"
          borderRadius="md"
          bg="white"
          boxShadow="xs"
        >
          <Link
            href={attachment.url}
            target="_blank"
            rel="noopener noreferrer"
            color="blue.600"
            fontSize="sm"
            flex={1}
            minW={0}
            isTruncated
            title={attachment.name}
          >
            {attachment.name}
          </Link>
          {onRemove && (
            <Button
              type="button"
              size="sm"
              h={7}
              px={2}
              flexShrink={0}
              variant="ghost"
              colorScheme="red"
              leftIcon={<FiTrash2 />}
              aria-label={`Remover ${attachment.name}`}
              onClick={() => onRemove(attachment.id)}
            >
              Remover
            </Button>
          )}
        </Flex>
      ))}
    </Stack>
  );
};

export default PcdAttachments;
